import { _O } from ".";
import { SocketCommand, socketManager } from "../../components/AppProvider";

export const loginVarify = (param) => {
  if (param === "KAKAO" || param === "400") {
    window.location.href = "ep://login/verifyKakao";
  } else if (param === "NAVER" || param === "100") {
    window.location.href = "ep://login/verifyNaver";
  } else if (param === "APPLE" || param === "600") {
    socketManager(SocketCommand.LOGIN_APPLE, appleLoginAf, {});
  } else {
    _O.Open("/membership/chkPw");
  }
};

const appleLoginAf = (userEmail, userName, UID, signUpChannel) => {
  _O.Open("/membership/snsVerify/" + UID);
};
